jQuery(document).ready(function() {
    wowo(jQuery);
    copyHtml();
    productHeight();
    headlineAnimate();
    slider();
    headerMenu();
    page_scroll();
    parallax();
    accordionToggle();
    selectMonitor();
    sort();
    teacherIframe();
    inputFocus();
    layoutToggle();

    if(jQuery('.shopify-app-block').length > 0){
        jQuery('.shopify-app-block').parents('section').addClass('review-app-block');
    }

    if(jQuery("#instafeed").length>0){
        var InstagramToken = $("#instafeed").attr('data-key');
        var link = $("#instafeed").attr('data-link');
        var feed = new Instafeed({
            accessToken: InstagramToken,
            limit: 4,
            template: '<li><a href=' + link + ' target="_blank"><div class="wowo zoomOut" style="background-image: url({{image}})"></div></a></li>',
            after: function () {},
        });
        feed.run();
    }
    if((!jQuery('.home-screen').length) && (!jQuery('.banner').length) ){
      jQuery('header').addClass('no-banner');
    }
});

jQuery(window).scroll(function(){
    wowo(jQuery);
    parallax();
    productHeight();

    if (jQuery(document).scrollTop() >40){
        jQuery('header').addClass('sticky');
    } else {
        jQuery('header').removeClass('sticky');
    }

});

jQuery(window).resize(function () {
    productHeight();

    if(jQuery(window).width() >= 1280){
        jQuery('html').removeClass('body-hidden');
        jQuery('.hamburger').removeClass('open');
        jQuery('header nav').removeClass('open');
        jQuery('.header-main').removeClass('show-inner-menu');
        jQuery('.inner-menu-block').hide();
    }
});

function headlineAnimate(){
    jQuery('.headline-animate').each(function(){
        var me = jQuery(this);
        var wordGroup = me.text().split(' ');
        var strongGroup = me.find('strong').text().split(' ');
        me.html('');
        for(var i = 0;i < wordGroup.length;i++){
            me.append('<span class="outer wowo wordUp delay-in-' + (i+1) + '"><span class="inner">' + wordGroup[i] + '</span></span>');
        }
        for(var j = 0;j < strongGroup.length;j++){
            for(var k = 0;k < me.find('.inner').length;k++){
                if(strongGroup[j] == wordGroup[k]){
                    me.find('.outer').eq(k).addClass('strong');
                    me.find('.outer').eq(k).append('<span class="mask wowo mask-show delay-in-' + (wordGroup.length+1) + '"></span>');
                    if(j == 0){
                        me.find('.outer').eq(k).find('.mask').addClass('first');
                    }else if(j == strongGroup.length-1){
                        me.find('.outer').eq(k).find('.mask').addClass('last');
                    }
                    // me.find('.outer').eq(k).find('.inner').addClass('mask delay-in-' + wordGroup.length);
                }
            }
        }
    })
}

function wowo($) {
    setTimeout(function () {
        jQuery('html').addClass("show-c");
        
        var wTop = jQuery(window).scrollTop(), wHeight = jQuery(window).height(), wBottom = wTop + wHeight;
        jQuery(".wowo:not(.animated)").each(function () {
            var me = jQuery(this), meTop = me.offset().top, meHeight = me.height(), meBottom = meTop + meHeight,
                    limitTop = wTop - meHeight, limitBottom = wBottom + meHeight;
            if (meTop > limitTop && meBottom < limitBottom) {
                me.addClass("animated");
            }
        })
    }, 100);
}

function copyHtml(){
    if(jQuery('.label-slider').length > 0){
        var copyContent = jQuery('.label-slider').html();
        for(var i = 0;i < 10;i++){
            var showContent = jQuery('.label-slider').html();
            jQuery('.label-slider').html(showContent + copyContent);
        }
    }

    if(jQuery('.seen-in-slider').length > 0){
        var copyContent = jQuery('.seen-in-slider').html();
        for(var i = 0;i < 10;i++){
            var showContent = jQuery('.seen-in-slider').html();
            jQuery('.seen-in-slider').html(showContent + copyContent);
        }
    }
}

function productHeight(){
    if(jQuery('.books-gallery').length > 0 && jQuery('.books-gallery .book-item').length > 4){
        jQuery('.books-gallery .book-item').find('.text').css('min-height','unset');
        var maxH = 0;
        for(var i = 0;i < jQuery('.books-gallery .book-item').length;i++){
            var itemH = jQuery('.books-gallery .book-item').eq(i).find('.text').outerHeight();
            if(itemH > maxH){
                maxH = itemH;
            }
        }
        jQuery('.books-gallery .book-item').find('.text').css('min-height',maxH + 'px');
    }
}

function layoutToggle(){
    jQuery('body').on('click','.layout-btns .btns',function(){
        jQuery(this).addClass('active').siblings().removeClass('active');
    })

    jQuery('body').on('click','.layout-btns .gallery-style-btn',function(){
        jQuery(this).parents('section').removeClass('list-style');
    })

    jQuery('body').on('click','.layout-btns .list-style-btn',function(){
        jQuery(this).parents('section').addClass('list-style');
    })
}

function headerMenu(){
    jQuery('body').on('mouseover','header .has-menu',function(){
        if(jQuery(window).width() >= 1280){
            jQuery('.has-menu').removeClass('drop-down');
            jQuery(this).addClass('drop-down');
            jQuery('.header-main').addClass('show-inner-menu');
            jQuery(this).parent().siblings().find('.inner-menu-block').fadeOut(400);
            jQuery(this).next('.inner-menu-block').fadeIn(400).css('display','flex');
        }
    })

    jQuery('body').on('mouseover','header .navbar-list>li>a:not(.has-menu)',function(){
        if(jQuery(window).width() >= 1280){
            jQuery('.header-main').removeClass('show-inner-menu');
            jQuery('.has-menu').removeClass('drop-down');
            jQuery('.inner-menu-block').fadeOut(400);
        }
    })

  
    jQuery('body').on('mouseleave','header',function(){
        if(jQuery(window).width() >= 1280){
            jQuery('.header-main').removeClass('show-inner-menu');
            jQuery('.has-menu').removeClass('drop-down');
            jQuery('.inner-menu-block').fadeOut(400);
        }
    })

    jQuery('body').on('click','header .has-menu',function(){
        if(jQuery(window).width() < 1280){
            jQuery('.header-main').toggleClass('show-inner-menu');
            jQuery(this).toggleClass('drop-down');
            jQuery(this).parent().siblings().find('.has-menu').removeClass('drop-down');
            jQuery(this).parent().siblings().find('.inner-menu-block').fadeOut(400);
            jQuery(this).next('.inner-menu-block').slideToggle(300).css('display','flex');
        }
    })

    jQuery('body').on('click','.hamburger',function(){
        jQuery('html').toggleClass('body-hidden');
        jQuery(this).toggleClass('open');
        jQuery('header nav').toggleClass('open');
        setTimeout(function(){
            jQuery('header .icon-search').toggleClass('show');
        }, 300);
    })

    jQuery('body').on('click','.header-main .icon-search',function(){
        jQuery('.search-modal').toggleClass('search-open');
        jQuery('.search-modal .search__input').val('');
    })

    jQuery('body').on('click','.search-modal .modal__close-button',function(){
        jQuery('.search-modal').removeClass('search-open');
    })
}

function page_scroll(){
    jQuery(".scroll").click(function(event){
        var sTop = jQuery('header').height();
        event.preventDefault();
        jQuery('html,body').animate({scrollTop:jQuery(this).parents('.shopify-section').next().offset().top - sTop},800);
    });
}

function parallax() {
    if(jQuery(window).width() >= 768){
        var wh = jQuery(window).height();
        var sh = jQuery(window).scrollTop();
        jQuery(".parallax-s").each(function(){
            var parallax_h = jQuery(this).offset().top;
            if(sh>(parallax_h-wh)){
                var parallax_y = -(sh-(parallax_h-wh))/12;
                // var attgroup = 'center ' + parallax_y;
                // jQuery(this).css('background-position','center ' + parallax_y + 'px');
                jQuery(this).css('top',parallax_y);
            }
        });
    }else{
        // jQuery('.parallax-s').css('background-position','center');
        jQuery(this).css('top',0);
    }
}

function teacherIframe(){
    if(jQuery('.accordion-item .video-list iframe').length > 0){
        jQuery('.accordion-item .video-list iframe').each(function(){
            jQuery(this).wrap('<div class="video-box"></div>');
        })

        jQuery('.accordion-item .video-list .video-box').each(function(){
            jQuery(this).wrap('<div class="video-item"></div>');
        })
    }
}

function accordionToggle() {
    jQuery('body').on('click','.accordion-item .item-head',function(){
        var scroll = jQuery(this).parents('.accordion-item').offset().top - jQuery('header').outerHeight() - 20;

        if(jQuery('.accordion-item.is-open').length > 0){
            var click = jQuery(this).parent('.accordion-item').index();
            var current = jQuery('.accordion-item.is-open').index();
            if(click > current){
                scroll -= jQuery('.accordion-item.is-open .item-body').height();
            }
        }

        jQuery(this).parents('.accordion-item').toggleClass('is-open');
        jQuery(this).siblings().slideToggle(400);

        jQuery(this).parents('.accordion-item').siblings().removeClass('is-open');
        jQuery(this).parents('.accordion-item').siblings().find('.item-body').slideUp(400);

        jQuery('html,body').animate({scrollTop:scroll},400);
    })
}

function selectMonitor() {
    jQuery('body').on('click','.donate-block select',function(event){
        jQuery('.select-arrow').toggleClass('open');
        event.stopPropagation();
    })

    jQuery('body').on('click',function(){
        jQuery('.select-arrow').removeClass('open');
    })

    jQuery('.donate-block select').on('change',function(){
        jQuery('.select-placeholder').hide();
        jQuery('.donate-block select').css('opacity','1');
    })
}

function slider(){
    if(jQuery('.home-screen .kids-slider').length>0){
        jQuery('.home-screen .kids-slider').slick({
            slidesToShow:1,
            slidesToScroll: 1,
            fade: true,
            arrows: false,
            dots: false,
            autoplay: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            infinite: true,
            speed: 500,
            autoplaySpeed: 7000
        });
    }

    if(jQuery('.banner .wallpaper .img').length>1){
        jQuery('.banner .wallpaper').slick({
            slidesToShow:1,
            slidesToScroll: 1,
            fade: true,
            arrows: false,
            dots: false,
            autoplay: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            infinite: true,
            speed: 500,
            autoplaySpeed: 7000
        });
    }

    if(jQuery('.header-top-banner-slider').length>0){
        jQuery('.header-top-banner-slider').slick({
            slidesToShow:1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            autoplay: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            infinite: true,
            speed: 500,
            autoplaySpeed: 7000
        });
    }

    if(jQuery('.label-slider').length>0){  
        jQuery('.label-slider').slick({
            slidesToShow:1,
            // slidesToScroll: 1,
            arrows: false,
            dots: false,
            autoplay: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            infinite: true,
            speed: 1000,
            autoplaySpeed: 5000,
            touchThreshold: 50,
            variableWidth: true
        });
    }

    if(jQuery('.seen-in-slider').length>0){  
        jQuery('.seen-in-slider').slick({
            slidesToShow:1,
            arrows: false,
            dots: false,
            autoplay: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            infinite: true,
            speed: 1000,
            autoplaySpeed: 5000,
            touchThreshold: 50,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        centerMode: true
                    }
                }
            ]
        });
    }

    if(jQuery('.quote-slider').length>0 && jQuery('.quote-item').length > 1){  
        jQuery('.quote-slider').slick({
            slidesToShow:1,
            slidesToScroll: 1,
            fade: true,
            arrows: false,
            dots: false,
            autoplay: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            infinite: true,
            speed: 1000,
            autoplaySpeed: 5000
        });
    }

    if(jQuery('.books-gallery').length > 0 && jQuery('.books-gallery .book-item').length > 4){
        jQuery('.books-gallery').slick({
            slidesToShow:4,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            autoplay: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            infinite: false,
            speed: 1000,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 1441,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
}

function sort(){
    jQuery('body').on('click','.sort-tools>span',function(event){
        jQuery(this).siblings('ul').fadeToggle(200);
        jQuery('.sort-value').toggleClass('active');
        event.stopPropagation();
    })

    jQuery('body').on('click',function(){
        if(jQuery('.sort-tools ul').length > 0){
            jQuery('.sort-value').removeClass('active');
            jQuery('.sort-tools ul').fadeOut(200);
        }
    })
}

function inputFocus(){
    jQuery('body').on('focus','.quantity__input',function(){
        jQuery(this).select();
    })
}

function appHeight() {
    const doc = document.documentElement;
    doc.style.setProperty('--vh', (window.innerHeight * .01) + 'px');
}

window.addEventListener('resize', appHeight);
appHeight();